import Service from './Service'

export const SERVICES = {
  getCategories: {
    type: 'get',
  },
  getCategoryDetails: {
    type: 'get',
    urlParam: '/:id',
    serviceBase: 'category',
  },
  getCategoryFortuneTellers: {
    type: 'get',
    urlParam: '/:id/fortune_tellers',
  },
}

/**
 * Instance of Categories Service.
 *
 * @class
 * @usage `import CategoriesService from '~/network/CategoriesService'`
 */
export default class CategoriesService extends Service {
  constructor(props) {
    super(props)
    this.services = SERVICES
  }

  serviceBase() {
    return 'categories'
  }
}
